import Input from 'components/common/inputs/Input';
import ShadowCard from 'components/common/cards/ShadowCard';
import useValidationConsolidator from 'hooks/useValidationConsolidator';
import MarketsList from 'constants/markets';

function GeneralSection(props) {
  const markets = new MarketsList();
  const { config, data = {}, isValid, inputs: dictionary, name } = props;
  const fields = config?.enrollment?.form?.sections?.[name]?.fields || [];
  const { title } = data;

  const arrayOfInputValidationFunctions = useValidationConsolidator(fields, allFieldsValidApiCall);

  function allFieldsValidApiCall(validationValue) {
    isValid(validationValue);
  }

  if (!fields?.length) return null;

  return (
    <>
      <ShadowCard title={title}>
        <div className="form-max flex-20 column">
          {fields.map((field, index) => {
            return (
              <Input
                id={field}
                key={`${name}-${field}`}
                dictionary={dictionary}
                isValid={arrayOfInputValidationFunctions[index]}
                data={data}
                country={config.market}
                market={markets.find(config?.market).country}
                dataTestId={`input-${field}`}
                validateOnMount={config.inputs?.[field]?.validateOnMount}
              />
            );
          })}
        </div>
      </ShadowCard>
    </>
  );
}
export default GeneralSection;
